import script from "./AvisoLegal.vue?vue&type=script&setup=true&lang=js"
export * from "./AvisoLegal.vue?vue&type=script&setup=true&lang=js"

import "./AvisoLegal.vue?vue&type=style&index=0&id=28e44a10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e44a10"]])

export default __exports__